/*
/*
 * @Date: 2020-09-07 09:41:02
 * @Author: lvjun
 * @Description: 路由
 */
const serviceReport = [ // 首页
  {
    path: 'historicalConversation',
    name: 'historicalConversation',
    component: () => import('@/views/service-report/HistoricalConversation.vue'),
    meta: {
      title: '历史会话记录',
      keepAlive: true
    }
  },
  {
    path: 'customerSessionQuery',
    name: 'customerSessionQuery',
    component: () => import('@/views/service-report/CustomerSessionQuery.vue'),
    meta: {
      title: '客服会话查询',
      keepAlive: true
    }
  },
  {
    path: 'serviceProviderSessionQuery',
    name: 'serviceProviderSessionQuery',
    component: () => import('@/views/service-report/ServiceProviderSessionQuery.vue'),
    meta: {
      title: '服务商会话查询',
      keepAlive: true
    }
  },
  {
    path: 'LargeScreenBoardHq',
    name: 'LargeScreenBoardHq',
    component: () => import('@/views/service-report/LargeScreenBoardHq.vue'),
    meta: {
      title: '大屏展板',
      keepAlive: true
    }
  }
]
export default serviceReport
